import React from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from '../../components/UI/Loading';
import { useWordSearchSubmissions } from '../../hooks/useSubmissions';
/**
 * WordSearch submissions listing component
 * Features:
 * - Automatic data fetching using TanStack Query
 * - Tabular display of submissions
 * - Loading state handling
 * - Error state handling
 * - Empty state messaging
 */
const ListWordSearchSubmissions = () => {
    const params = useParams();
    const wordSearchId = params.id;
    const { data: submissions, isLoading, error, } = useWordSearchSubmissions(wordSearchId);
    if (isLoading)
        return React.createElement(Loading, null);
    if (error) {
        return (React.createElement("div", { className: "submissions-container" },
            React.createElement("p", null,
                "Error loading submissions: ",
                error.message)));
    }
    return (React.createElement("div", { className: "submissions-container" }, submissions && submissions.length > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "submission-column--name" },
            React.createElement("div", { className: "submission--header" },
                React.createElement("p", null, "Name")),
            submissions.map((sub, i) => (React.createElement("div", { key: i, className: `submission${i % 2 === 0 ? '--alt' : ''}` },
                React.createElement("p", null, sub.name))))),
        React.createElement("div", { className: "submission-column--email" },
            React.createElement("div", { className: "submission--header" },
                React.createElement("p", null, "Email")),
            submissions.map((sub, i) => (React.createElement("div", { key: i, className: `submission${i % 2 === 0 ? '--alt' : ''}` },
                React.createElement("p", null, sub.email))))),
        React.createElement("div", { className: "submission-column--score" },
            React.createElement("div", { className: "submission--header" },
                React.createElement("p", null, "Score")),
            submissions.map((sub, i) => (React.createElement("div", { key: i, className: `submission${i % 2 === 0 ? '--alt' : ''}` },
                React.createElement("p", null, sub.score))))))) : (React.createElement("p", null, "No Submissions so far..."))));
};
export { ListWordSearchSubmissions };
